import { Div, Label } from "@grassrootly/rn-core";
import { ScrollView } from "react-native";
import GamePlayers from "../../common/game/game-attendees/GamePlayers";
import { GameVotingSectionProps } from "./GameVote.types";

export default function GameSectionVote({ attendees, onSelected, selectedId, title }: GameVotingSectionProps) {
  return (
    <Div classNames={["flex1"]}>
      <Label type="l1Bold" classNames={["colorPrimaryMain", "mb-{16}", "textCenter"]}>
        {title}
      </Label>
      <ScrollView style={{ flex: 1 }}>
        <GamePlayers attendees={attendees} onSelected={onSelected} selectedId={selectedId} />
      </ScrollView>
    </Div>
  );
}
